module.exports = __webpack_public_path__ + "img/logo-bigpicture-poweredby.fa36bff7.svg";